/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React, { useEffect } from 'react';
import HeaderNav from './HeaderNav';
import Footer from './Footer';

interface LayoutProps {
  user: string | null;
  navAlwaysOn?: boolean;
  children: React.ReactNode;
}

const Layout = ({ user, navAlwaysOn = false, children }: LayoutProps) => {
  useEffect(() => {
    const onScroll = () => {
      const nav = document.getElementById('tf-menu');
      if (!nav) return;
      if (navAlwaysOn) {
        nav.classList.add('on');
        return;
      }
      const navHeight = window.innerHeight - 100;
      nav.classList.toggle('on', window.scrollY > navHeight);
    };

    window.addEventListener('scroll', onScroll);
    onScroll();

    const collapseEl = document.getElementById('bs-example-navbar-collapse-1');
    const links = document.querySelectorAll('.navbar-nav li a');
    const onClick = () => {
      const toggler = document.querySelector('.navbar-toggler') as HTMLElement | null;
      if (!toggler || getComputedStyle(toggler).display === 'none') return;
      const bootstrap = window.bootstrap;
      const bsCollapse = bootstrap?.Collapse?.getInstance(collapseEl);
      if (bsCollapse) bsCollapse.hide();
    };

    links.forEach((a) => a.addEventListener('click', onClick));

    return () => {
      window.removeEventListener('scroll', onScroll);
      links.forEach((a) => a.removeEventListener('click', onClick));
    };
  }, [navAlwaysOn]);

  return (
    <>
      <HeaderNav user={user} />
      {children}
      <Footer />
    </>
  );
};

export default Layout;
